import delegate from 'delegate-it';

class Header {
  constructor(rootElement) {
    this.rootElement = rootElement;

    this.initUiState();
    this.attachEvents();
  }

  initUiState() {
    this.uiState = {
      menuVisibility: 'hidden',
    };
  }

  attachEvents() {
    delegate(this.rootElement, '[data-entity="burger"]', 'click', this.burgerClickHandler.bind(this));
  }

  burgerClickHandler() {
    this.uiState.menuVisibility = this.uiState.menuVisibility === 'hidden' ? 'shown' : 'hidden';

    this.renderRootElement();
  }

  renderRootElement() {
    const { menuVisibility } = this.uiState;

    if (menuVisibility === 'hidden') {
      this.rootElement.classList.remove('header_menu-shown');
    }

    if (menuVisibility === 'shown') {
      this.rootElement.classList.add('header_menu-shown');
    }
  }
}

export default Header;
